import { createReducer, on } from '@ngrx/store';

import { ICompanyLogoState, initialCompanyLogoState } from './companyLogo.state';
import { CompanyLogoLoaded } from './companyLogo.actions';


export const initialState: ICompanyLogoState = {
  logo: null
};

const setLogo = (state: ICompanyLogoState, { logo }: { logo: string | null }) => ({
  ...state,
  logo
});


const _companyLogoReducer = createReducer<ICompanyLogoState>(
  initialCompanyLogoState,
  on(CompanyLogoLoaded, setLogo)
);

export function companyLogoReducer(state: ICompanyLogoState, action): ICompanyLogoState {
  return _companyLogoReducer(state, action);
}
